type ConsumableStatus = 'healthy' | 'warning' | 'critical';

export const computeConsumableStatus = (consumed: number, total: number): ConsumableStatus => {
    if (total <= 0) {
        return consumed > 0 ? 'critical' : 'healthy';
    }

    if (consumed > total) {
        return 'critical';
    }

    const remainingPercent = ((total - consumed) / total) * 100;
    return remainingPercent < 15 ? 'warning' : 'healthy';
};

export const getConsumableStatusNote = (
    consumed: number,
    total: number,
): { id: string; overage?: number } | undefined => {
    const status = computeConsumableStatus(consumed, total);
    if (status === 'critical') {
        return {
            id: 'CLIENT_CONSUMABLE_V2_NOTE_OVERUSAGE',
            overage: consumed - total,
        };
    }
    if (status === 'warning') {
        return { id: 'CLIENT_CONSUMABLE_V2_NOTE_NEEDS_ATTENTION' };
    }
    return undefined;
};
